import { AppRouteGroup } from '#/routing/classes/AppRouteGroup';

export const embedSearchWidgetRouteGroup = new AppRouteGroup(
  '/:lang/embed-search-widget/:embedSearchWidgetId',
);
